// extracted by mini-css-extract-plugin
export default {"container":"Hq-z","heading":"Iq-z","text":"Jq-z","info":"Kq-z","link":"Lq-z","fullMaxWidth":"Mq-z"};